import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors} from '@angular/forms';

@Directive({
  selector: '[appMinNumber], [appMaxNumber]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: MinMaxNumberDirective, multi: true },
  ],
})
export class MinMaxNumberDirective {
  @Input() appMinNumber: Number;
  @Input() appMaxNumber: Number;

  constructor() { }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validateDate(control);
  }

  private validateDate(control: AbstractControl) {
    if (!(control && Number.isFinite(+control.value))) {
      return null;
    }

    const numberToCheck = +control.value;

    if (Number.isFinite(numberToCheck) && Number.isFinite(+this.appMinNumber) && +this.appMinNumber > numberToCheck) {
      return { appMinNumber: true };
    }

    if (Number.isFinite(numberToCheck) && Number.isFinite(+this.appMaxNumber) && +this.appMaxNumber < numberToCheck) {
      return { appMaxNumber: true };
    }

    return null;
  }

}
